const errors = {
  docs: []
}

export default {
  list: [],
  initialErrors: { ...errors },
  errors: { ...errors }
}



// WEBPACK FOOTER //
// ./src/features/manager_invoices/store/state.js